import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../components/ui/Button";
import { supabase } from "../lib/supabaseClient";
import { useEffect } from "react";

export default function Signup() {

  useEffect(() => {
  document.title = "Signup | HD Labs";
}, []);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(""); // <-- error state
  const [form, setForm] = useState({ email: "", password: "", confirmPassword: "" });

  function onChange(e) {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
    setError(""); // clear error when user types
  }

  async function onSubmit(e) {
    e.preventDefault();

    // Check if passwords match
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);

    const { error: supabaseError } = await supabase.auth.signUp({
      email: form.email.trim(),
      password: form.password,
    });

    setLoading(false);

    if (supabaseError) {
      setError(supabaseError.message);
      return;
    }

    navigate("/my-orders");
  }

  return (
    <div className="mt-12 mb-12 bg-slate-50">
      <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white border border-slate-200 rounded-2xl p-6">
          <h1 className="text-2xl font-semibold text-slate-900">Create account</h1>
          <p className="mt-2 text-sm text-slate-600">
            Create an account to track your orders.
          </p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <Field label="Email" name="email" type="email" value={form.email} onChange={onChange} />
            <Field label="Password" name="password" type="password" value={form.password} onChange={onChange} />
            <Field
              label="Confirm Password"
              name="confirmPassword"
              type="password"
              value={form.confirmPassword}
              onChange={onChange}
            />

            {/* Inline error message */}
            {error && <p className="text-red-600 text-sm mt-1">{error}</p>}

            <Button className="w-full" disabled={loading}>
              {loading ? "Creating..." : "Create account"}
            </Button>
          </form>

          <div className="mt-5 text-sm text-slate-600">
            Already have an account?{" "}
            <Link className="font-semibold text-blue-900 hover:underline" to="/login">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, className = "", ...props }) {
  return (
    <div className={className}>
      <label className="text-xs text-slate-600">{label}</label>
      <input
        {...props}
        className="mt-2 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-slate-300"
      />
    </div>
  );
}